/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_HeadingInputs */

const en_us2_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let's start with your email`)
};

const pt_br2_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos começar pelo seu e-mail`)
};

const es_419_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empecemos con tu email`)
};

const pt_pt2_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vamos começar pelo teu e-mail`)
};

const fr_fr2_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commençons par ton e-mail`)
};

const de_de2_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fangen wir mit deiner E-Mail an`)
};

const it_it2_auth_email_heading = /** @type {(inputs: Auth_Email_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniziamo dalla tua email`)
};

/**
* | output |
* | --- |
* | "Let's start with your email" |
*
* @param {Auth_Email_HeadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_email_heading = /** @type {((inputs?: Auth_Email_HeadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_HeadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_email_heading(inputs)
	if (locale === "es-419") return es_419_auth_email_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_email_heading(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_email_heading(inputs)
	if (locale === "de-DE") return de_de2_auth_email_heading(inputs)
	if (locale === "it-IT") return it_it2_auth_email_heading(inputs)
	return en_us2_auth_email_heading(inputs)
});
export { auth_email_heading as "auth.email_heading" }